import moment from 'helpers/moment'
import React, {useContext} from 'react'

import {makeStyles} from 'external/material'
import Box from '@mui/material/Box'
import Fade from '@mui/material/Fade'
import TableContainer from '@mui/material/TableContainer'
import Table from '@mui/material/Table'

import {TeacherContext} from 'teacher/context'

import StudentGradesSummaryHead from './student-grades-summary-head'
import StudentGradesSummaryBody from './student-grades-summary-body'

const useStyles = makeStyles(studentGradesSummaryStyles)

export default function StudentGradesSummary() {

  const {query, rollbookContextGrades: grades, groupsLoaded} = useContext(TeacherContext)
  const classes = useStyles()  

  return (
    <Box className={classes.root} > 
      <TableContainer className={classes.container}>
        <Fade in={groupsLoaded && grades.loaded}>
          <Table className={classes.table}>
            <StudentGradesSummaryHead />
            <StudentGradesSummaryBody />
          </Table>
        </Fade>
      </TableContainer>
    </Box>
  )
}

function studentGradesSummaryStyles(theme) {
 return {
    root: {
    },
    container: {
      flexGrow: 1,
      flexShrink: 0,
      overflow: 'auto',
      border: 'solid 1px #d8dbe0',
      borderTop: 0,
      borderBottom: 0,
      [theme.breakpoints.down('xs')]: {
        border: 0
      }
    },
  }
}
